import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { componenteService } from '../services/componenteService';
import { formatNumber } from "../utils/numberFormat";

export default function ComponenteDetail() {
    const { tipo, id } = useParams();
    const navigate = useNavigate();
    const [comp, setComp] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const cargar = async () => {
            try {
                if (!componenteService[tipo]) {
                    setError('Tipo de componente inválido');
                    return;
                }
                const data = await componenteService[tipo].getById(id);
                setComp(data);
            } catch (err) {
                console.error(err);
                setError('Error al cargar componente');
            }
        };
        cargar();
    }, [tipo, id]);

    if (error) return (
        <div className="page-wrapper">
            <button onClick={() => navigate(-1)}>← Volver</button>
            <h2>Error</h2>
            <p>{error}</p>
        </div>
    );

    if (!comp) return (
        <div className="page-wrapper">
            <button onClick={() => navigate(-1)}>← Volver</button>
            <h3>Cargando...</h3>
        </div>
    );

    return (
        <div className="page-wrapper">
            <button onClick={() => navigate(-1)}>← Volver</button>
            <h2>{comp.nombre} <small style={{color:'#666'}}>[{comp.type || tipo}]</small></h2>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 320px', gap: 20 }}>
                <div>
                    <h3>Items</h3>
                    {Array.isArray(comp.items) && comp.items.length > 0 ? (
                        <table className="table">
                            <thead>
                                <tr><th>Nombre</th><th>Costo</th></tr>
                            </thead>
                            <tbody>
                                {comp.items.map((it, idx) => (
                                    <tr key={idx}><td>{it.nombre}</td><td>${formatNumber(it.costo)}</td></tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div>
                            <p style={{color:'#666'}}>No hay ítems</p>
                            {comp.items && console.warn('comp.items is not an array:', comp.items)}
                        </div>
                    )}

                    <h3 style={{ marginTop: 20 }}>Detalle</h3>
                    <div style={{ whiteSpace: 'pre-wrap', color:'#333' }}>
                        <div>Id: {comp.id}</div>
                        <div>Costo total: ${formatNumber(comp.costoTotal || 0)}</div>
                        <div>Costo materiales: ${formatNumber(comp.costoMateriales || 0)}</div>
                    </div>
                </div>

                <aside style={{ borderLeft: '1px solid #eee', paddingLeft: 16 }}>
                    <h4>Metadatos</h4>
                    <div><strong>Nombre</strong>: {comp.nombre}</div>
                    <div><strong>Tipo</strong>: {comp.type || tipo}</div>
                    <div><strong>Items</strong>: {comp.items?.length || 0}</div>
                </aside>
            </div>
        </div>
    );
}
